import Icon from '../components/Icon.vue'

Icon.register({
  at: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8C118.9 8 8 118.9 8 256 8 393.1 118.9 504 256 504 304.2 504 351.3 489.9 391.4 463.8 403.4 456 406 439.5 397 428.4L386.8 416C379.1 406.6 365.6 404.3 355.4 410.8 325.9 429.8 291.3 440 256 440 154.5 440 72 357.5 72 256S154.5 72 256 72C356.1 72 440 129.6 440 232 440 270.8 418.9 311.7 381.8 315.7 364.5 315.2 364.9 302.8 368.4 285.7L391.8 164.6C394.7 149.8 383.3 136 368.2 136H323.2A13.5-13.5 0 0 1 309.8 148L309.8 148.1C295.1 130.2 269.4 126.3 249.8 126.3 175.3 126.3 112 188.5 112 277.8 112 343.1 148.8 383.6 208 383.6 235 383.6 265.4 368 283 345.3 292.5 379.4 323.6 379.4 353.7 379.4 462.6 379.4 504 307.8 504 232 504 95.7 394 8 256 8zM234.3 312.4C212.1 312.4 198.3 296.8 198.3 271.7 198.3 226.7 229 198.9 256.9 198.9 279.2 198.9 292.5 214.2 292.5 239.7 292.5 284.8 258.6 312.4 234.3 312.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/at.js
// module id = Vn/n
// module chunks = 144